export default "__VITE_ASSET__6HprDaBo__"